import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface SelectedCompanies {
    companiesIds: number[]
  }

const initialState: SelectedCompanies = {
    companiesIds: []
}

export const backofficeSelectedCompaniesSlice = createSlice({
    name: 'backofficeSelectedCompanies',
    initialState,
    reducers: {
      changeSelectedCompanies: (state, action: PayloadAction<SelectedCompanies>) => {
        state.companiesIds = action.payload.companiesIds
      }
    }
  })
  
  export const { changeSelectedCompanies } = backofficeSelectedCompaniesSlice.actions